import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "fwdRef", "invalid", "multiple", "size"];
import React, { forwardRef, useContext } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
import { FormContext } from '../form/form';
import { FormRowContext } from '../form-row/form-row';
/**
 * _An input control that allows users to make a single selection from a list of options._
 *
 * ***
 *
 * The component is a minimal wrapper around the HTML `<select>`. Children
 * should be HTML `<option>` or `<optgroup>` elements. Additional props
 * (including `ref`) will be forwarded to the `<select>` element.
 *
 * Options list style depends on the browser and system, i.e. it is not
 * customized in any way.
 *
 * The component does not support `size` and `multiple` attributes of the HTML `<select>`.
 */
export const Select = _ref => {
  let {
      className,
      fwdRef,
      invalid,
      size: propSize
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacing
  } = useContext(FormContext);
  const {
    disabled,
    id,
    required
  } = useContext(FormRowContext);
  const size = propSize != null ? propSize : spacing;
  return /*#__PURE__*/React.createElement("select", _extends({
    "aria-invalid": invalid ? true : undefined,
    disabled: disabled,
    id: id,
    required: required
  }, props, {
    className: buildVersionedClassNames('ds-select', className, {
      ["ds-select--" + size]: size !== 'default',
      'ds-select--invalid': invalid
    }),
    ref: fwdRef
  }));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Select, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Select';
export default Fwd;